exports.catchallErrorMessage = `Please try again later or <a href='/contact' target='_blank' style='color: red; text-decoration: underline;'>contact us</a>.`;

exports.timezones = Object.freeze({
	'AST': 'America/Puerto_Rico',
	'EST': 'America/New_York', 
	'CST': 'America/North_Dakota/New_Salem', 
	'MST': 'America/Denver',
	'MST (Arizona)': 'America/Phoenix',
	'PST': 'America/Los_Angeles',
	'AKST': 'America/Juneau',
	'HST': 'Pacific/Honolulu'
});

exports.stateOptions = Object.freeze([
	"",
	"AL",
	"AK",
	"AZ",
	"AR",
	"CA",
	"CO",
	"CT",
	"DE",
	"FL",
	"GA",
	"HI",
	"ID",
	"IL",
	"IN",
	"IA",
	"KS",
	"KY",
	"LA",
	"ME",
	"MD",
	"MA",
	"MI",
	"MN",
	"MS",
	"MO",
	"MT",
	"NE",
	"NV",
	"NH",
	"NJ",
	"NM",
	"NY",
	"NC",
	"ND",
	"OH",
	"OK",
	"OR",
	"PA",
	"RI",
	"SC",
	"SD",
	"TN",
	"TX",
	"UT",
	"VT",
	"VA",
	"WA",
	"WV",
	"WI",
	"WY",
]);

exports.stateOptionsPlusOnlineOther = Object.freeze([
		...exports.stateOptions.slice(0, 1),
		// ...["Online", "Other"],
		...["Other"],
		...exports.stateOptions.slice(1)
]);

exports.MAXDAYSINMONTH = Object.freeze([31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]);